// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"c626e960","70":"8ec0900f","132":"83e7b605","366":"7190b1a1","543":"443f7bc7","887":"edfd4056","924":"34709188","942":"f204b517","998":"8abc2ba4"}[chunkId] + ".chunk.js";
};